var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',_vm._g(_vm._b({class:{'d-inline-flex': _vm.flex },attrs:{"color":_vm.color,"dark":""}},'v-toolbar',_vm.$attrs,false),_vm.$listeners),[_c('v-toolbar-title',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }